import React, { useEffect, useState } from "react";
import { Medal, Star } from "lucide-react";
import Reveal from "@/components/Reveal";
import { Container, SectionHeader, Eyebrow } from "@/components/Section";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);

export default function PublicStarTeacher() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/recognition/public").then(r => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data || !data.current) return null;
  const c = data.current;
  const archive = data.archive || [];

  return (
    <section className="py-16 sm:py-24 bg-slate-50" data-testid="public-star-teacher-section">
      <Container>
        <Reveal>
          <div className="text-center">
            <Eyebrow>Recognition</Eyebrow>
            <SectionHeader title="PTG Star Teacher — 15 Day Award" subtitle="Celebrating responsible, consistent and meaningful mentoring at PTG." />
          </div>
        </Reveal>
        <Reveal>
          <div className="mt-8 mx-auto max-w-2xl rounded-3xl bg-gradient-to-br from-blue-900 to-sky-700 text-white p-8 sm:p-10 text-center shadow-xl" data-testid="star-teacher-current">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-400 text-amber-950"><Medal className="h-9 w-9" /></div>
            {c.photo_url && <img src={imgUrl(c.photo_url)} alt={c.teacher_name} className="mx-auto h-28 w-28 rounded-full object-cover ring-4 ring-white/30 mb-4" />}
            <p className="text-xs uppercase tracking-widest text-sky-200 font-semibold">{c.period_label}</p>
            <h3 className="mt-1 text-3xl font-extrabold" data-testid="star-teacher-name">{c.teacher_name}</h3>
            {c.message && <p className="mt-3 text-sky-100 max-w-lg mx-auto">"{c.message}"</p>}
            <div className="mt-4 inline-flex items-center gap-1.5 text-amber-300 font-semibold"><Star className="h-4 w-4 fill-amber-300" /> PTG Star Teacher</div>
          </div>
        </Reveal>
        {archive.length > 0 && (
          <Reveal>
            <div className="mt-10">
              <p className="text-center text-sm font-semibold text-slate-500 uppercase tracking-widest mb-4">Past Star Teachers</p>
              <div className="flex flex-wrap justify-center gap-4" data-testid="star-teacher-archive">
                {archive.map(a => (
                  <div key={a.id} className="rounded-2xl bg-white border border-slate-200 p-4 w-44 text-center shadow-sm" data-testid={`archive-card-${a.id}`}>
                    {a.photo_url ? <img src={imgUrl(a.photo_url)} alt={a.teacher_name} className="mx-auto h-16 w-16 rounded-full object-cover mb-2" /> : <div className="mx-auto h-16 w-16 rounded-full bg-blue-900 text-white flex items-center justify-center font-bold mb-2">{a.teacher_name?.charAt(0)}</div>}
                    <p className="font-bold text-slate-900 text-sm leading-tight">{a.teacher_name}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{a.period_label}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        )}
      </Container>
    </section>
  );
}
